import { cn } from '@/lib/utils'

const FULL_LOGO_SRC = '/brand/arh-full.png'
const SIMPLE_LOGO_SRC = '/brand/arh-simple.png'

interface ArhLogoProps {
  className?: string
  imageClassName?: string
  framed?: boolean
  markOnly?: boolean
}

export function ArhLogo({ className, imageClassName, framed = false, markOnly = false }: ArhLogoProps) {
  const img = (
    <img
      src={markOnly ? SIMPLE_LOGO_SRC : FULL_LOGO_SRC}
      alt={markOnly ? 'Ascendant Road Holdings mark' : 'Ascendant Road Holdings LLC'}
      className={cn('block h-auto select-none', framed ? 'w-full' : className, imageClassName)}
      draggable={false}
    />
  )

  if (!framed) return img

  return (
    <div className={cn(
      'inline-flex items-center justify-center rounded-md border border-gold/30',
      'bg-cream-warm/95 shadow-elevated backdrop-blur-sm',
      className,
    )}>
      {img}
    </div>
  )
}
